// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__37fp8","info":"Note_info__2a_lK","note":"Note_note__1p-A2","actions":"Note_actions__3TMHB"};